import { FC, useContext } from 'react'
import { ChatContext } from '../context/ChatContext'
import { ModalDialog, ModalDialogBody, ModalDialogButtons, ModalDialogTitle } from '../../common/components/ModalDialog'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Button } from '../../common/components/Button'
import { useChatManualSupportMutation } from './useChatManualSupportMutation'

const List = styled('ul')`
  display: flex;
  flex-direction: column;
  gap: 0.25em;
  margin: 0.75rem 0 1rem;
  padding: 0;
  padding-inline-start: 1.25em;
  text-align: start;
`

export const ChatManualSupportPrompt: FC = () => {
  const { t } = useTranslation()
  const { manualSupportPromptOpened, setManualSupportPromptOpened } = useContext(ChatContext)
  const { isPending, mutate } = useChatManualSupportMutation()

  return (
    <ModalDialog
      opened={manualSupportPromptOpened}
      onClose={() => {
        if (!isPending) {
          setManualSupportPromptOpened(false)
        }
      }}
    >
      <ModalDialogBody>
        <ModalDialogTitle>{t('Send by mail')}</ModalDialogTitle>

        <List>
          <li>{t('Your request will be sent to your branch agent.')}</li>
          <li>{t('They will contact you and/or email a quote shortly.')}</li>
          <li>{t('You will receive a copy of this request in your email.')}</li>
        </List>

        <ModalDialogButtons>
          <Button
            big
            primary
            disabled={isPending}
            onClick={() => {
              mutate()
            }}
          >
            {isPending ? t('Loading...') : t('Confirm')}
          </Button>

          <Button
            big
            disabled={isPending}
            onClick={() => {
              setManualSupportPromptOpened(false)
            }}
          >
            {t('Cancel')}
          </Button>
        </ModalDialogButtons>
      </ModalDialogBody>
    </ModalDialog>
  )
}
